import { COUNTRIES } from "../resources/data_countries";

export function getCountryOptions() {
    return COUNTRIES.map((c:any) => ({ key: c.code.toUpperCase(), value: { es: c.name } }));
}
  
export function getStates(countryCode: string) {
    const country = COUNTRIES.find((c:any) => c.code === countryCode);
    return country?.states?.map((state: any) => ({
        key: state.code,
        value: { 
            es: state.name, 
            en: state.name,
            pt: state.name,
        },
    })) || [];
}
  
export function getDialCode(countryOrigin: string) {
    return COUNTRIES.find((c:any) => c.code === countryOrigin)?.dialCode || '';
}

export function searchStateByName(countryCode: string, stateName: string) {
    const country = COUNTRIES.find((c:any) => c.code === countryCode);
    if (!country) return null;

    const state = country.states.find((s:any) => s.name.toLowerCase() === stateName.toLowerCase());
    return state || null;
}
